import type { DataUpload } from '@/common/data-upload';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

/**
 * Re-runs the tile server conversion for a tileset (retry a failed one or re-tile
 * a ready one). The backend proxies to the tile server and persists the refreshed
 * status. Returns the updated record (status back to queued/processing).
 */
export async function reprocessTileset(id: string): Promise<DataUpload | null> {
	const response = await axios.post(API_URLS.DATA_UPLOAD.TILESET_REPROCESS(id));
	return getResponse<DataUpload>(response.data);
}
